var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(5.011 4.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1140",
    "data-name": "Rectangle 1140",
    width: 32,
    height: 32,
    transform: "translate(-5.011 -4.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4552",
    "data-name": "Path 4552",
    d: "M14,13a4,4,0,1,1,4-4,4,4,0,0,1-4,4Zm0-6.666A2.667,2.667,0,1,0,16.666,9,2.667,2.667,0,0,0,14,6.333Z",
    transform: "translate(-3.004 -1.334)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4553",
    "data-name": "Path 4553",
    d: "M11.963,26.92a10,10,0,0,1-7.726-3.66l-.347-.427.347-.42a10,10,0,0,1,15.453,0l.347.42-.347.427A10,10,0,0,1,11.963,26.92Zm-6.326-4.08a8.666,8.666,0,0,0,12.666,0,8.666,8.666,0,0,0-12.666,0Z",
    transform: "translate(-0.967 -5.922)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4554",
    "data-name": "Path 4554",
    d: "M11,21a10,10,0,1,1,7.726-3.66A10,10,0,0,1,11,21ZM11,2.333A8.666,8.666,0,1,0,19.662,11,8.666,8.666,0,0,0,11,2.333Z",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4555",
    "data-name": "Path 4555",
    d: "M5.18,23.129s6.713,7.5,13.546.747l.88-.747s-5.706-5.92-11.5-2.367Z",
    transform: "translate(-1.397 -6.21)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_937",
    "data-name": "Ellipse 937",
    cx: 3.333,
    cy: 3.333,
    r: 3.333,
    transform: "translate(7.663 4.333)",
    fill: "#09c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfo);
export default __webpack_public_path__ + "static/media/personal-info.b3a57a01b5537cbde707c882a6c78d25.svg";
export { ForwardRef as ReactComponent };